import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import { Box, Container, Typography, useMediaQuery } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import _ from 'lodash'
import React, { useEffect } from 'react'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Speedometer, {
  Background,
  Arc,
  Needle,
  Progress,
  Marks,
  Indicator,
  DangerPath,
} from 'react-speedometer'
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  BarChart,
  Bar,
  ReferenceLine,
} from 'recharts'

import {
  getChartObd,
  getObdChart,
  getObdsTopChart,
  getTopObdsChart,
  resetChartObd,
} from '../../store/devices'
const ChartInfoEngineScreen = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch<Dispatch<any>>()
  const ChartObd = useSelector(getObdsTopChart)
  const reverse = [...ChartObd]

  // توابع مربوط به دریافت اطلاعات براساس مقادیر از جمله فشار محیط و غیره برای نمایش در نمودار
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'AAS.Pressure') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'AAS.Pressure',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'AAS.PressureVolt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'AAS.PressureVolt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'AAS.Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'AAS.Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'AAS.TempVolt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'AAS.TempVolt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ACCPedal.Position') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ACCPedal.Position',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ACCPedal.Volt1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ACCPedal.Volt1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ACCPedal.Volt2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ACCPedal.Volt2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BAT.CH') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BAT.CH',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BAT.CU') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BAT.CU',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BAT.TE') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BAT.TE',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BAT.VoltBattery') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BAT.VoltBattery',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Canister.Angle') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Canister.Angle',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Canister.Level') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Canister.Level',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Canister.Status') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Canister.Status',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Coil.DwellTime1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Coil.DwellTime1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Coil.DwellTime2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Coil.DwellTime2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Coil.DwellTime3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Coil.DwellTime3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Coil.DwellTime4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Coil.DwellTime4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Coil.DwellTimeAVG') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Coil.DwellTimeAVG',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Cooler.GasPressure') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Cooler.GasPressure',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Cooler.PowerConsumption') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Cooler.PowerConsumption',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'CPS.Position') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'CPS.Position',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'CPS.SetPoint') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'CPS.SetPoint',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'CTS.Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'CTS.Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'CTS.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'CTS.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'EGR.Angle') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'EGR.Angle',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Engine.Load') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Engine.Load',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Engine.Runtime') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Engine.Runtime',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Fan.Speed') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Fan.Speed',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'FLS.Level') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'FLS.Level',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'FLS.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'FLS.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Gearbox.Ratio') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Gearbox.Ratio',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.B1Ltft') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.B1Ltft',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.B1Stft') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.B1Stft',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.B2Ltft') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.B2Ltft',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.B2Stft') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.B2Stft',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTime1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTime1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTime2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTime2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTime3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTime3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTime4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTime4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTime5') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTime5',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTime6') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTime6',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTime7') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTime7',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTime8') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTime8',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTimeAVG1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTimeAVG1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'injection.InjectionTimeAVG2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'injection.InjectionTimeAVG2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])

  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Knock.Value') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Knock.Value',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'MAF.AbsolutePressure') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'MAF.AbsolutePressure',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'MAF.MAFCoefficient') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'MAF.MAFCoefficient',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'MAF.MassFlowRate') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'MAF.MassFlowRate',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'MAF.Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'MAF.Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'MAF.TempVolt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'MAF.TempVolt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'MAF.Pressure') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'MAF.Pressure',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ODO.DTCClear') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ODO.DTCClear',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ODO.FaultSpeed') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ODO.FaultSpeed',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ODO.Gas') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ODO.Gas',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ODO.General') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ODO.General',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ODO.MILON') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ODO.MILON',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ODO.Petrol') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ODO.Petrol',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oil.Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oil.Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Status1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Status1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Status2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Status2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Status3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Status3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Status4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Status4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Stft1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Stft1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Stft2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Stft2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Stft3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Stft3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Stft4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Stft4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Volt1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Volt1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Volt1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Volt1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Volt3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Volt3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B1Volt4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B1Volt4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Status1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Status1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Status2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Status2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Status3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Status3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Status4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Status4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Stft1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Stft1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Stft2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Stft2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Stft3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Stft3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Stft4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Stft4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Volt1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Volt1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Volt2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Volt2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Volt3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Volt3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Oxygen.B2Volt4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Oxygen.B2Volt4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'RPM.IdleSet') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'RPM.IdleSet',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'RPM.Value') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'RPM.Value',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Stepper.Step') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Stepper.Step',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Stepper.Trim') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Stepper.Trim',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.OffsetB') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.OffsetB',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.OffsetC') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.OffsetC',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.PosB') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.PosB',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.PosC') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.PosC',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.PosCMD') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.PosCMD',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.PosCal') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.PosCal',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.Status') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.Status',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.VoltB') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.VoltB',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'TPS.VoltC') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'TPS.VoltC',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'VSS.Fault') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'VSS.Fault',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
    // navigate(`/${routes.CARS}`)
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'VSS.Value') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'VSS.Value',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'MAP.Press') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'MAP.Press',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'MAP.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'MAP.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'IAT.Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'IAT.Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'IAT.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'IAT.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.Afr') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.Afr',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.MisFire1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.MisFire1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.MisFire2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.MisFire2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.MisFire3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.MisFire3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.MisFire4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.MisFire4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.MisFire5') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.MisFire5',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.MisFire6') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.MisFire6',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.MisFire7') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.MisFire7',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.MisFire8') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.MisFire8',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvance1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvance1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvance2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvance2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvance3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvance3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvance4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvance4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvance5') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvance5',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvance6') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvance6',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvance7') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvance7',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvance8') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvance8',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvanceAVG1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvanceAVG1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingAdvanceAVG2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingAdvanceAVG2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetard2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetard2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetard3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetard3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetard4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetard4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetard5') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetard5',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetard6') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetard6',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetard7') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetard7',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetard8') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetard8',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnock1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnock1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnock2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnock2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnock3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnock3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnock4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnock4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnock5') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnock5',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnock6') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnock6',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnock7') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnock7',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnock8') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnock8',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Combustion.TimingRetardKnockAVG') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Combustion.TimingRetardKnockAVG',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ATS.Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ATS.Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'ATS.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'ATS.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APS.Press') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APS.Press',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APS.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APS.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APP.OffsetD') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APP.OffsetD',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APP.OffsetE') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APP.OffsetE',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APP.PosCal') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APP.PosCal',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APP.PosD') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APS.Press',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APP.PosE') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APP.PosE',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APP.VoltD') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APP.VoltD',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'APP.VoltE') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'APP.VoltE',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'VPS.Press') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'VPS.Press',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'VPS.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'VPS.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'WGC.Angle') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'WGC.Angle',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'DCV.Angle') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'DCV.Angle',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Evaporator.Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Evaporator.Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Evaporator.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Evaporator.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'FPS.Press') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'FPS.Press',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'FPS.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'FPS.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'FRP.Press') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'FRP.Press',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'FRP.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'FRP.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'EFR.Avg') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'EFR.Avg',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'EFR.Instance') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'EFR.Instance',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Accelarator.Value') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Accelarator.Value',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Accelarator.Value') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Accelarator.Value',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Alternator.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Alternator.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BPS.DesiredPress') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BPS.DesiredPress',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BPS.Press') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BPS.Press',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BPS.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BPS.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BBS.Press') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BBS.Press',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BBS.Volt') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BBS.Volt',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'BTS.Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'BTS.Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Catalyst.B1S1Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Catalyst.B1S1Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Catalyst.B1S2Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Catalyst.B1S2Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Catalyst.B2S1Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Catalyst.B2S1Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Catalyst.B2S2Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Catalyst.B2S2Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'EGT.B1S1Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'EGT.B1S1Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'EGT.B1S2Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'EGT.B1S2Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'EGT.B2S1Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'EGT.B2S1Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'EGT.B2S2Temp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'EGT.B2S2Temp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Torque.Abs') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Torque.Abs',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Torque.Cmd') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Torque.Cmd',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Torque.Desired') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Torque.Desired',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.InjectionTime1') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.InjectionTime1',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.InjectionTime2') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.InjectionTime2',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.InjectionTime3') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.InjectionTime3',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.InjectionTime4') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.InjectionTime4',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.RailPress') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.RailPress',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.RailTemp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.RailTemp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.RegulatorPress') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.RegulatorPress',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.TankLevel') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.TankLevel',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.TankPress') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.TankPress',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Bifuel.TankTemp') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Bifuel.TankTemp',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Status.Mask') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Status.Mask',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])
  useEffect(() => {
    if (ChartObd === undefined) return
    if (location.state.oBDProperty === 'Status.Value') {
      const refreshIntervalId = setInterval(() => {
        dispatch(
          getTopObdsChart({
            deviceId: location.state.location,
            top: 10,
            oBDProperty: 'Status.Value',
          }),
        )
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [ChartObd])

  // تابع تبدیل تاریخ شمسی به میلادی
  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }
  const c = reverse.reverse()
  const a = c?.map((p: any) => {
    return { dateTime: shamsi(p.data.dateTime), مقدار: p.data.value, top: p.data.value }
  })
  const b = a?.map((u) => Number(u.top))
  const largest = b.length > 0 ? Math.max(...b) : undefined

  useEffect(() => {
    return () => {
      dispatch(resetChartObd)
    }
  }, [])
  const matches = useMediaQuery('(min-width:600px)')

  const responsiveValue = matches ? 250 : 210
  return (
    <Container fixed maxWidth='sm' sx={{ overflow: 'hidden' }}>
      <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2, direction: 'ltr' }}>
        <ArrowBackRoundedIcon
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: 'red',
            borderRadius: '50%',
            color: '#fff',
            cursor: 'pointer',
          }}
        />
        <img alt='Logo' src='images/TinyLogo.png' />
      </Box>
      <Box display='flex' justifyContent='center'>
        <Typography>{location.state.title}</Typography>
      </Box>
      <div dir='ltr'>
        <LineChart
          data={a}
          height={300}
          // margin={{ top: 5, right: 10, bottom: 5, left: 0 }}
          width={matches ? 380 : 320}
        >
          <Line dataKey='مقدار' stroke='#8884d8' type='monotone' />
          <CartesianGrid stroke='#ccc' strokeDasharray='5 5' />
          <XAxis dataKey='dateTime' />
          <YAxis domain={[0, largest !== undefined ? largest : 6000]} />
          <Tooltip />
        </LineChart>
        <Box display='flex' justifyContent='center'>
          {location.state.oBDProperty === 'RPM.Value' && (
            <Speedometer
              fontFamily='squada-one'
              max={8}
              value={ChartObd !== undefined ? ChartObd[ChartObd.length - 1]?.data?.value / 1000 : 0}
              width={responsiveValue}
            >
              <Background />
              <Arc arcWidth={4} />
              <Needle baseOffset={40} circleRadius={30} />
              <DangerPath />
              <Progress arcWidth={10} />
              <Marks step={0.5} />
              <Indicator>
                {(value, textProps) => (
                  <text
                    {...textProps}
                    fill='white'
                    fontFamily='Vazir'
                    fontSize={matches ? 15 : 10}
                    textAnchor='middle'
                    x={matches ? 250 / 2 : 220 / 2}
                    y={matches ? 80 : 60}
                  >
                    <>x1000rpm</>
                  </text>
                )}
              </Indicator>
              <Indicator>
                {(value, textProps) => (
                  <text
                    {...textProps}
                    fill='white'
                    fontFamily='Vazir'
                    fontSize={15}
                    textAnchor='middle'
                    x={matches ? 250 / 2 : 200 / 2}
                    y={matches ? 210 : 180}
                  >
                    <>دور موتور</>
                  </text>
                )}
              </Indicator>
            </Speedometer>
          )}
        </Box>
      </div>
    </Container>
  )
}

export default ChartInfoEngineScreen
